import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import { COL_UPLOAD_LOGS } from "../constants";

export async function createUploadLog({
  fileName,
  uploadedBy,
  totalRecords,
  successRecords,
  failedRecords,
  duplicateRecords,
  totalSalesAmount,
  weekNumber,
  periodKey,
  year,
  month,
  weekOfMonth,
  fromDate,
  toDate,
  weeklyImportId,
  duplicateMode,
}) {
  const payload = {
    fileName: fileName || "",
    uploadedBy: uploadedBy || "",
    uploadDate: new Date().toISOString(),
    totalRecords: Number(totalRecords) || 0,
    successRecords: Number(successRecords) || 0,
    failedRecords: Number(failedRecords) || 0,
    duplicateRecords: Number(duplicateRecords) || 0,
    totalSalesAmount: Number(totalSalesAmount) || 0,
    weekNumber: weekNumber || periodKey || "",
    periodKey: periodKey || weekNumber || "",
    year: year ?? null,
    month: month ?? null,
    weekOfMonth: weekOfMonth ?? null,
    fromDate: fromDate || "",
    toDate: toDate || "",
    weeklyImportId: weeklyImportId || "",
    duplicateMode: duplicateMode || "skip",
  };
  const ref = await addDoc(collection(db, COL_UPLOAD_LOGS), payload);
  return ref.id;
}
